var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { SearchResultItemWrapper, SearchResultIcon, SearchResultTextWrapper, SearchResultHeading, SearchResultContentWrapper, SearchResultContent, SearchResultContentDevider, SearchResultIconWrapper, } from './styles';
import DefaultAppIcon from '../../../images/default-app-icon.png';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { capitalizeFirst, dateFormat } from '../../../utils';
import { platformVersionToString } from '../../../utils/version';
import { makeSelectPlatformVersion } from '../selectors';
var getHighlightedText = function (nameText, highlight) {
    if (nameText === void 0) { nameText = ''; }
    if (highlight === void 0) { highlight = ''; }
    var originalWords = nameText.split(' ').filter(function (item) { return item !== ''; });
    var lowerWords = nameText
        .toLowerCase()
        .split(' ')
        .filter(function (item) { return item !== ''; });
    var searchWords = highlight
        .toLowerCase()
        .split(' ')
        .filter(function (item) { return item !== ''; });
    return originalWords.map(function (originalPart, index) {
        var lowerPart = lowerWords[index];
        return (_jsx("span", { children: searchWords.some(function (el) { return lowerPart === el; }) ? (_jsxs("b", { children: [originalPart, " "] })) : (_jsxs(_Fragment, { children: [originalPart, " "] })) }, "".concat(originalPart, "_").concat(index)));
    });
};
var ResultCard = function (props) {
    var selected = props.selected, appDetails = props.appDetails, searchString = props.searchString, updateSelectedItemOnMouseMove = props.updateSelectedItemOnMouseMove, resultCardRef = props.resultCardRef, mouseMoveActive = props.mouseMoveActive, setAppData = props.setAppData, setUpdateModalOpen = props.setUpdateModalOpen;
    var navigate = useNavigate();
    var platformVersion = useSelector(makeSelectPlatformVersion());
    var navigateToApp = function () {
        var latestMinorVersion = platformVersion.minor;
        var appMinorVersion = appDetails.platform_version.minor;
        if (latestMinorVersion - appMinorVersion > 2) {
            setUpdateModalOpen(true);
        }
        else {
            var goToAppLink = "/organizations/".concat((appDetails === null || appDetails === void 0 ? void 0 : appDetails.org_id) || 'shared', "/apps/").concat(appDetails === null || appDetails === void 0 ? void 0 : appDetails.id, "/overview");
            navigate(goToAppLink);
        }
    };
    return (_jsxs(SearchResultItemWrapper, __assign({ selected: selected, onMouseEnter: function () {
            mouseMoveActive && updateSelectedItemOnMouseMove(appDetails === null || appDetails === void 0 ? void 0 : appDetails.id);
            setAppData(appDetails);
        }, ref: resultCardRef }, { children: [_jsx(SearchResultIconWrapper, __assign({ onClick: navigateToApp }, { children: _jsx(SearchResultIcon, { src: (appDetails === null || appDetails === void 0 ? void 0 : appDetails.icon) || DefaultAppIcon }) })), _jsxs(SearchResultTextWrapper, __assign({ onClick: navigateToApp }, { children: [_jsx(SearchResultHeading, { children: getHighlightedText(appDetails === null || appDetails === void 0 ? void 0 : appDetails.name, searchString) }), _jsxs(SearchResultContentWrapper, { children: [_jsxs(SearchResultContent, { children: [appDetails === null || appDetails === void 0 ? void 0 : appDetails.org_name.substring(0, 20), (appDetails === null || appDetails === void 0 ? void 0 : appDetails.org_name.length) > 21 && '...'] }), _jsx(SearchResultContentDevider, {}), _jsx(SearchResultContent, { children: platformVersionToString(appDetails === null || appDetails === void 0 ? void 0 : appDetails.platform_version) }), _jsx(SearchResultContentDevider, {}), _jsxs(SearchResultContent, { children: ["Created on", ' ', dateFormat(Number(moment(appDetails === null || appDetails === void 0 ? void 0 : appDetails.created_at).format('D'))), " of", ' ', capitalizeFirst(moment(appDetails === null || appDetails === void 0 ? void 0 : appDetails.created_at).format('MMM YYYY'))] })] })] }))] })));
};
export default ResultCard;
